export const MOUNT_POINTS = [
  { name: '강서', rtcmTypes: ['GANS-RTCM31', 'GANS-RTCM32'] },
  { name: '강화', rtcmTypes: ['GANH-RTCM31', 'GANH-RTCM32'] },
  { name: '금천', rtcmTypes: ['GUMC-RTCM31', 'GUMC-RTCM32'] },
  { name: '남양주', rtcmTypes: ['NAMY-RTCM31', 'NAMY-RTCM32'] },
  { name: '도봉', rtcmTypes: ['DBON-RTCM31', 'DBON-RTCM32'] },
  { name: '동두천', rtcmTypes: ['DOND-RTCM31', 'DOND-RTCM32'] },
  { name: '서여주', rtcmTypes: ['YEOJ-RTCM31', 'YEOJ-RTCM32'] },
  { name: '서울', rtcmTypes: ['SOUL-RTCM31', 'SOUL-RTCM32'] },
  { name: '송파', rtcmTypes: ['SONP-RTCM31', 'SONP-RTCM32'] },
  { name: '수원', rtcmTypes: ['SUWN-RTCM31', 'SUWN-RTCM32'] },
  { name: '안성', rtcmTypes: ['ANSG-RTCM31'] },
  { name: '양주', rtcmTypes: ['YANJ-RTCM31', 'YANJ-RTCM32'] },
  { name: '양평', rtcmTypes: ['YANP-RTCM31', 'YANP-RTCM32'] },
  { name: '용산', rtcmTypes: ['YONS-RTCM31', 'YONS-RTCM32'] },
  { name: '의정부', rtcmTypes: ['OJBU-RTCM31', 'OJBU-RTCM32'] },
  { name: '이천', rtcmTypes: ['ICHN-RTCM31', 'ICHN-RTCM32'] },
  { name: '인천', rtcmTypes: ['INCH-RTCM31', 'INCH-RTCM32'] },
  { name: '창원', rtcmTypes: ['CHWN-RTCM31', 'CHWN-RTCM32'] },
  { name: '파주', rtcmTypes: ['PAJU-RTCM31', 'PAJU-RTCM32'] },
  { name: '파주문산', rtcmTypes: ['PJMS-RTCM31', 'PJMS-RTCM32'] },
  { name: '팔미도', rtcmTypes: ['PALM-RTCM30', 'PALM-RTCM32'] },
  { name: '포천', rtcmTypes: ['POCN-RTCM31', 'POCN-RTCM32'] },
];
